<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils :key="entity.id" :title="entity.id > 0 ? `Contrato ${entity.number}` : 'Criar Novo Contrato'"/>
      <breadcrumb
          :items="[{label: 'Pesquisa de Contratos', path: '/proposals'}, {label: entity.id > 0 ? `Contrato ${entity.number}` : 'Criar Novo Contrato', path: $router.currentRoute.path}]"/>

      <transition name="tab" mode="out-in">
        <div class="container-fluid-grid" v-if="entity.id">
          <div class="row">
            <div class="col-12 t-r">
              <h4 class="titles" :class="{'canceled': entity.canceled}"><span class="lbl">NÚMERO<svg-icon
                  icon="chevron-right"/></span> <span class="val">{{ entity.number }} <span v-if="entity.canceled">(CANCELADO)</span></span>
              </h4>
              <h4 class="titles"><span class="lbl">DATA<svg-icon icon="chevron-right"/></span> <span
                  class="val">{{ entity.created_at }}</span></h4>
              <h4 class="titles"><span class="lbl">VALOR TOTAL<svg-icon icon="chevron-right"/></span> <span class="val">R$ {{
                  entity.calculate_total
                }}</span>
              </h4>
              <h4 class="titles"><span class="lbl">VALOR COMISSÃO<svg-icon icon="chevron-right"/></span> <span
                  class="val">R$ {{ entity.calculate_commission }}</span></h4>
            </div>
          </div>
        </div>
      </transition>
      <form @submit.prevent.stop="submit" novalidate>
        <ibox type="tab_right">
          <template v-slot:title>
            <h5 v-if="!$appUtils.isMobile()">
              <svg-icon icon="handshake"/>
              Dados do Contrato
            </h5>
          </template>

          <template v-slot:tabs>
            <Tabs :tabs="tabs" @onTabSelected="onTabSelected"/>
          </template>

          <template v-slot:content>
            <transition name="tab" mode="out-in">
              <GeneralArea :entity="entity" :errors="errors" v-if="currentTab === 0"/>
              <FixingArea :entity="entity" v-else-if="currentTab === 1"
                          @onSendByEmail="selectTypePdf"
                          @onUpdateTabs="updateTabBadges"/>
              <AddendumArea :entity="entity"
                            @onSendByEmail="selectTypePdf"
                            @onUpdateTabs="updateTabBadges"
                            v-else-if="currentTab === 2"/>
              <FinanceArea :financial_movements="entity.financial_movements" v-else/>
            </transition>

            <modal v-if="itemToEmail !== null"
                   size="medium"
                   id="addendumModal"
                   :buttons="modalEmailButtons"
                   title="Enviar por e-mail">
              <span slot="header">Enviar por e-mail</span>

              <div class="container-fluid-grid" slot="body">
                <div class="form-row">
                  <div class="col-12 form-group">
                    <label for="addendumEmails" class="required">E-mail(s)</label>

                    <SelectX
                        :key="selectXKey"
                        validator-input="email"
                        input-id="addendumEmails"
                        placeholder="Informe os e-mails que deseja enviar"
                        v-model="selectedEmails"
                        :data-source="emailsDataSource"
                    />
                    <field-messages :errors="errors.emails"/>
                  </div>
                </div>
              </div>
            </modal>

            <modal v-if="showCancel"
                   size="medium"
                   id="cancelModal"
                   :buttons="modalCancelButtons"
                   title="Cancelar">

              <div class="container-fluid-grid" slot="body">
                <div class="form-row">
                  <div class="col-12 form-group">
                    <label for="cancelProposalTextArea" class="required">Informe o motivo</label>

                    <textarea id="cancelProposalTextArea"
                              maxlength="500"
                              required
                              :class="{'is-invalid': errors.cancel_reason.length > 0}"
                              v-model="cancelReason"
                              class="form-control form-control-sm"></textarea>

                    <field-messages :errors="errors.cancel_reason"/>
                  </div>
                </div>
              </div>
            </modal>
          </template>
          <template v-slot:footer>
            <div class="container-fluid-grid">
              <div class="row">
                <div class="col t-r">
                  <span class="btn-group btn-group-sm" role="group">
                      <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon
                          icon="sync"/> Limpar</button>
                      <router-link to="/proposals" class="btn btn-dark btn-sm"><svg-icon
                          icon="search"/> Pesquisar</router-link>

                      <Dropdown label="Salvar"
                                :key="entity.id"
                                menu-position="up"
                                button-label="Salvar"
                                button-class="btn btn-sm btn-theme-1 not-b-r-bottom-left not-b-r-top-left"
                                button-caret-class="btn btn-sm btn-theme-1"
                                btn-class="btn-sm btn-warning not-b-r-top-left not-b-r-bottom-left"
                                button-type="submit"
                                v-if="!entity.canceled"
                                :show-caret="entity.id > 0"
                                icon="save">
                          <template v-slot:items>
                              <li>
                                  <router-link
                                      :to="{path: '/pdf-viewer', query: {url: `/v1/proposals/view/pdf?id=${entity.id}&d=attachment`, name: `Confirmação de Negócio - ${entity.number}.pdf`}}"
                                  >
                                      <svg-icon icon="search"/>
                                      Visualizar PDF
                                  </router-link>
                              </li>
                              <li>
                                  <a href="javascript:void(0)"
                                     @click="downloadPdf">
                                      <svg-icon :class="{'refresh rotate-1-seg': downloadingPdf}"
                                                :icon="downloadingPdf ? 'sync' : 'cloud-download-alt'"/>
                                      Baixar PDF
                                  </a>
                              </li>
                              <li class="divider"></li>
                              <li>
                                  <router-link
                                      :to="{path: '/proposals/new', query: {clone: entity.id}}"
                                      title="Clonar contrato">
                                      <svg-icon icon="clone"/>
                                      Clonar
                                  </router-link>
                              </li>
                              <li class="divider"></li>
                              <li>
                                  <a href="javascript:void(0)"
                                     @click="selectTypePdf({id: entity.id, type: 'proposal'})">
                                      <svg-icon icon="envelope"/>
                                      Enviar por e-mail
                                  </a>
                              </li>
                              <li class="divider"></li>
                              <li v-if="$appStorage.userIsProfile(['admin', 'admin_all']) && !entity.canceled">
                                  <a href="javascript:void(0)"
                                     @click="() => {
                                          showCancel = true;
                                          cancelReason = null
                                      }">
                                      <svg-icon icon="ban"/>
                                      Cancelar
                                  </a>
                              </li>
                              <li v-if="!$appStorage.userIsProfile(['admin', 'admin_all']) && !entity.canceled">
                                  <a href="javascript:void(0)"
                                     @click="() => {
                                          modalRequest = {...modalRequest, show:true, mode: 'create'}
                                      }">
                                      <svg-icon icon="unlock"/>
                                      Solicitar Desbloqueio
                                  </a>
                              </li>
                              <li v-else-if="$appStorage.userIsProfile(['admin', 'admin_all'])">
                                  <a href="javascript:void(0)"
                                     @click="() => {
                                          modalRequest = {...modalRequest, show:true, mode: 'unlock'}
                                      }">
                                      <svg-icon icon="unlock"/>
                                      Dar Acesso
                                  </a>
                              </li>
                          </template>
                      </Dropdown>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </ibox>
      </form>
      <PermissionAccessModal v-if="modalRequest.show && entity.id > 0"
                             :mode="modalRequest.mode"
                             :id_reg="entity.id"
                             @closeModal="modalRequest.show = false"/>
    </template>
  </DefaultTmpl>
</template>

<script>
import CRUDEdit from '@/mixins/CRUDEdit'
import FieldMessage from "../../components/particles/FieldMessage";
import Tabs from '@/components/particles/Tabs'
import GeneralArea from './GeneralArea'
import FinanceArea from './FinanceArea'
import AddendumArea from './AddendumArea'
import FixingArea from './FixingArea'
import Dropdown from '@/components/particles/Dropdown'
import SelectX from '@/components/particles/SelectX'
import PermissionAccessModal from './PermissionAccessModal'
import {createNamespacedHelpers} from 'vuex'

const {mapActions} = createNamespacedHelpers('proposals');

export default {
  name: "ProposalsEdit",
  components: {
    FieldMessage,
    Tabs,
    GeneralArea,
    FinanceArea,
    AddendumArea,
    FixingArea,
    Dropdown,
    SelectX,
    PermissionAccessModal
  },
  mixins: [
    CRUDEdit.mount('proposals')
  ],
  data() {
    return {
      tabs: [{
        icon: 'info-circle',
        label: 'Dados',
        active: true
      }, {
        icon: 'divide',
        label: 'Fixação',
        active: false
      }, {
        icon: 'link',
        label: 'Adendos',
        active: false
      }, {
        icon: 'money-bill-wave',
        label: 'Financeiro',
        active: false,
        badge_class: 'theme-1'
      }],
      currentTab: 0,
      draftToken: null,
      modalRequest: {
        show: false,
        mode: 'create'
      },
      downloadingPdf: false,
      itemToEmail: null,
      selectedEmails: [],
      emailsDataSource: [],
      selectXKey: 1,
      errors: {
        emails: [],
        cancel_reason: [],
      },
      modalEmailButtons: [{
        label: 'Enviar Adendo',
        class: 'btn btn-theme-1 btn-sm',
        icon: 'envelope',
        iconClass: '',
        disabled: false,
        method: () => {
          this.sendEmail();
        }
      }, {
        type: 'close',
        label: 'Fechar',
        disabled: false,
        focus: true,
        method: () => this.itemToEmail = null
      }],
      modalCancelButtons: [{
        label: 'Cancelar',
        class: 'btn btn-danger btn-sm',
        icon: 'ban',
        method: () => {
          this.$delete(this.errors.cancel_reason, 0);

          if (this.$appUtils.isEmpty(this.cancelReason)) {
            this.errors.cancel_reason.push('Informe o motivo do cancelamento');
            return false
          }

          this.$store.commit('addModal', {
            title: 'Cancelamento', size: 'small', body: 'Deseja realmente cancelar esse contrato?', buttons: [
              {
                type: 'ok', class: 'btn btn-danger btn-sm', method: id => {
                  this.$store.commit('destroyModal', id);
                  this.cancel();
                }
              },
              {type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)}
            ]
          })
        }
      },
        {
          type: 'close',
          label: 'Fechar',
          disabled: false,
          focus: true,
          method: () => this.showCancel = false
        }
      ],
      showCancel: false,
      cancelReason: null
    }
  },
  methods: {
    ...mapActions(['loadCustomerAccounts', 'loadDraft']),
    // Preenche o formulário a partir de um rascunho preparado por um agente MCP
    // (docs/mcp/16-composites.md). A criação continua manual: o usuário revisa e
    // salva normalmente — o rascunho já vem no shape do show (selects inclusos).
    applyDraftIfPresent() {
      const token = this.$route.query.draft;
      if (!token) return;

      this.loadDraft(token)
          .then(({proposal}) => {
            // O draft vem no shape do show.json com valores INTERNOS (quantity
            // "38.0", price "135.5") — tem que passar pela mesma conversão por
            // campo do fluxo normal de edição, senão a máscara BR lê os dígitos
            // crus e 38 t viram "0,380". (Difere da NF, cujo draft já é BR.)
            this.onLoadSuccess(proposal || {});

            // Guarda o token para fechar o loop no save (o agente descobre o
            // desfecho por proposals_draft_status).
            this.draftToken = token;
            this.$snotify.info('Rascunho carregado. Revise os dados e salve o contrato.', 'Contrato preparado por IA');
          })
          .catch(() => {
            this.$snotify.warning('O rascunho não foi encontrado ou expirou (validade de 10 minutos).', 'Rascunho indisponível');
          });
    },
    cancel() {
      this.$appHttp.put(`/v1/proposals/cancel/${this.entity.id}`, {
        proposal: {
          canceled: true,
          canceled_reason: this.cancelReason
        }
      })
          .then(() => {
            this.$snotify.success(`Proposta ${this.entity.number} cancelada com sucesso.`, this.$appStorage.getUser().name);
            this.showCancel = false;
          })
          .catch(err => {
            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar cancelar a proposta.'}), this.$appStorage.getUser().name);
            console.error(err);
          });

    },
    clone() {
      this.entity = {
        ...this.entity,
        id: null,
        proposal_addendums_attributes: [],
        proposal_fixings_attributes: [],
        financial_movements: [],
        payment_type: null,
        is_billable: true,
        harvest: null,
        freight_type: null,
        quantity_embedded: null,
        billing_date: null,
        payment_date: null,
        broker_one_id: null,
        broker_one_commission: null,
        broker_two_id: null,
        broker_two_commission: null,
        broker_three_id: null,
        broker_three_commission: null,
        is_seller_require_assign: false,
        is_assign_seller: false,
        assign_seller_at: null,
        is_buyer_require_assign: false,
        is_assign_buyer: false,
        assign_buyer_at: null
      };

      this.updateTabBadges();

      this.$snotify.success('Confirmação clonada com sucesso.', this.$appStorage.getUser().name);
    },
    createEntity() {
      const mold = {
        id: null,
        seller_id: null,
        buyer_id: null,
        seller: {
          id: null,
          name: '',
          city: {
            name: null,
            state: {
              acronym: null
            }
          }
        },
        buyer: {
          id: null,
          name: ''
          ,
          city: {
            name: null,
            state: {
              acronym: null
            }
          }
        },
        is_seller_require_assign: false,
        is_assign_seller: false,
        is_buyer_require_assign: false,
        value_or_percent_commission: false,
        is_assign_buyer: false,
        assign_seller_at: null,
        assign_buyer_at: null,
        value_defined: 'value_defined',
        freight_type: null,
        price_type: null,
        price: null,
        price_description: null,
        description: null,
        product_id: null,
        harvest: null,
        quantity: null,
        quantity_embedded: null,
        is_billable: true,
        commission: null,
        percentage_commission: null,
        payment_type: null,
        special_condition: null,
        value_commission: null,
        broker_one_id: null,
        broker_one_commission: null,
        broker_two_id: null,
        broker_two_commission: null,
        broker_three_id: null,
        broker_three_commission: null,
        billing_date: null,
        payment_date: null,
        shipment_type: null,
        proposal_fixing_attributes: [],
      };

      const outer = this;
      Object.keys(mold).forEach(k => {
        outer.$set(outer.entity, k, mold[k]);
      });
    },
    beforeSubmit() {
      if (!/(value_defined|value_undefined)/.test(this.entity.price_type)) this.$set(this.entity, 'price_type', 'value_defined');
      // Fecha o loop do handoff (16b): repassa o token do rascunho ao salvar.
      if (this.draftToken && !this.entity.id) this.$set(this.entity, '_draft_token', this.draftToken);
    },
    onTabSelected(tab) {
      this.currentTab = tab.index;
    },
    onLoadSuccess(entity) {
      const outer = this;

      this.$set(this.entity, 'seller', {});
      this.$set(this.entity.seller, 'name', '');

      Object.keys(entity).forEach(k => {
        let val;
        if (/(_at|_date)$/.test(k)) {
          val = outer.$appUtils.formatDate(entity[k])
        } else if (/broker_(one|two|three)_commission$/.test(k)) {
          val = outer.$appUtils.formatNumber(entity[k], 1)
        } else if (/(percentage_commission)$/.test(k)) {
          val = outer.$appUtils.formatNumber(entity[k], 2)
        } else if (/(quantity|quantity_embedded)$/.test(k)) {
          val = outer.$appUtils.formatNumber(entity[k], 3)
        } else if (/(calculate_commission|calculate_total|value_commission|price)$/.test(k)) {
          val = outer.$appUtils.formatMoney(entity[k])
        } else {
          val = entity[k]
        }
        outer.$set(outer.entity, k, val);
      });

      this.updateTabBadges();

      const {clone} = this.$router.currentRoute.query;
      if (clone) this.clone();

      this.loadCustomerAccounts(entity.seller_id);
    },
    updateTabBadges() {
      const fins = this.entity.financial_movements;
      const fix = this.entity.proposal_fixings_attributes;
      const ads = this.entity.proposal_addendums_attributes;

      this.$set(this.tabs, 1, {...this.tabs[1], badge: (fix && fix.length > 0) ? fix.length : null});
      this.$set(this.tabs, 2, {...this.tabs[2], badge: (ads && ads.length > 0) ? ads.length : null});
      this.$set(this.tabs, 3, {...this.tabs[3], badge: (fins && fins.length > 0) ? fins.length : null});
    },
    // Único ponto de entrada do hook do CRUDEdit — NÃO duplicar esta chave: uma
    // segunda definição em `methods` sobrescreve esta em silêncio (foi o bug que
    // deixava o rascunho do MCP sem carregar: o hook do draft era a chave morta).
    onAfterRouteEnter() {
      this.applyDraftIfPresent();

      const {clone} = this.$router.currentRoute.query;
      if (clone) this.loadEntity(clone);
    },
    downloadPdf() {
      this.downloadingPdf = true;

      this.$appUtils.downloadPdf(`/v1/proposals/view/pdf?id=${this.entity.id}&d=attachment`, `Confirmação de Negócio - ${this.entity.number}.pdf`)
          .catch(err => {
            this.$snotify.error(this.$t('common.downloadPdfError'), this.$appStorage.getUser().name);
            console.error(err);
          })
          .finally(() => setTimeout(() => this.downloadingPdf = false, 1000));
    },
    selectTypePdf(item) {
      const params = new URLSearchParams({
        seller_id: this.entity.seller_id,
        buyer_id: this.entity.buyer_id,
      });

      this.modalEmailButtons[0].label = item.type === 'fixing' ? 'Enviar Fixação' : 'Enviar Adendo';

      this.emailsDataSource = [];

      this.$appHttp.get(`/v1/proposals/search/proposal_emails?${params.toString()}`)
          .then(({data}) => {
            Object.keys(data).forEach(k => this.emailsDataSource.push({
              id: data[k],
              label: data[k]
            }));

            this.selectXKey = new Date().getTime();
          })
          .catch(err => {
            this.$snotify.error(this.$t('commons.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao tentar carregar os e-mails relacionados ao contrato.'}), this.$appStorage.getUser().name);
            console.error(err);
          });

      this.selectedEmails = [];
      this.itemToEmail = item;
    },
    stateComponents(isBusy) {
      this.modalEmailButtons[0].disabled = isBusy;
      this.modalEmailButtons[0].icon = isBusy ? 'sync' : 'envelope';
      this.modalEmailButtons[0].iconClass = isBusy ? 'refresh rotate-1-seg' : '';
      this.modalEmailButtons[1].disabled = isBusy;
    },
    sendEmail() {
      this.errors.emails = [];
      if (this.selectedEmails.length === 0) {
        this.errors.emails.push('Informe os e-mails que deseja enviar');
      } else {
        this.stateComponents(true);

        let type = 'send_email'

        if (this.itemToEmail.type === 'fixing') type = 'send_email_fixing'
        else if (this.itemToEmail.type === 'addendum') type = 'send_email_addendum'

        const url = ['/v1/proposals/', type, '/', this.itemToEmail.id];

        this.$appHttp.post(url.join(''), {'to[]': this.selectedEmails.map(e => e.id)})
            .then(() => {
              this.$snotify.success(this.$t('common.sendEmailSuccessful'), this.$appStorage.getUser().name);
            })
            .catch(err => {
              this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar enviar o e-mail.'}), this.$appStorage.getUser().name);
              console.error(err);
            })
            .finally(() => this.stateComponents(false));
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "../../assets/css/variables";

.titles {
  margin: 0;
  display: inline-block;

  .lbl {
    font-size: 1em;

    svg {
      width: .7rem;
      height: .7rem;
    }
  }

  .val {
    padding-left: .4em;
    padding-right: .4em;
    font-size: 1.3em;
    color: $blue_primary;
  }

  &.canceled .val {
    color: $badge_red;
  }
}
</style>
